import { plural } from '@cian/utils';
import { NBSP } from '../../../../../shared/constants/symbols';

export const formatRetryPublishCountdown = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  const minutesStr = `${minutes} ${plural(minutes, ['минуту', 'минуты', 'минут'])}`;
  const secondsStr = `${seconds} ${plural(seconds, ['секунду', 'секунды', 'секунд'])}`;

  if (minutes === 0) {
    return secondsStr.replace(/ /g, NBSP);
  } else {
    return `${minutesStr} ${secondsStr}`.replace(/ /g, NBSP);
  }
};
